import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const services = [
    { name: "End of Tenancy Cleaning", path: "/end-of-tenancy" },
    { name: "Commercial Cleaning", path: "/commercial" },
    { name: "Residential Cleaning", path: "/residential" },
    { name: "Locksmith Services", path: "/locksmith" },
    { name: "Handyman Services", path: "/handyman" },
    { name: "Additional Services", path: "/additional-services" },
  ];

  const companyLinks = [
    { name: "About Us", path: "/about" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact Us", path: "/contact" },
    { name: "Get a Quote", path: "/get-quote" },
  ];

  return (
    <footer className="relative bg-navy-900 text-white overflow-hidden">
      {/* Geometric background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
      </div>

      {/* Diagonal accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 via-transparent to-cyan-400"></div>

      <div className="relative container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img
                src="/logo.png"
                alt="Shiny Crew Cleaning"
                className="h-16 w-auto mb-4"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Professional cleaning and maintenance services you can trust.
              Excellence in every detail.
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-cyan-400">
              Our Services
            </h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-gray-400 hover:text-white text-sm inline-flex items-center group"
                  >
                    <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2"></span>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h3 className="text-lg font-bold mb-4 mt-8 text-cyan-400">
              Company
            </h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white text-sm inline-flex items-center group"
                  >
                    <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-cyan-400">Contact Us</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start">
                <span className="text-cyan-400 font-bold mr-3">📞</span>
                <div>
                  <p className="text-gray-400">Phone</p>
                  <a
                    href="tel:03300545944"
                    className="text-white hover:text-cyan-400"
                  >
                    0330 054 5944
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <span className="text-cyan-400 font-bold mr-3">✉️</span>
                <div>
                  <p className="text-gray-400">Email</p>
                  <a
                    href="mailto:info@shinycrew.com"
                    className="text-white hover:text-cyan-400"
                  >
                    info@shinycrew.com
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <span className="text-cyan-400 font-bold mr-3">📍</span>
                <div>
                  <p className="text-gray-400">Location</p>
                  <p className="text-white">86-90 Paul Street</p>
                  <p className="text-white">London, EC2A 4NE</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Hours Column */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-cyan-400">
              Business Hours
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex justify-between">
                <span className="text-gray-400">Monday - Friday</span>
                <span className="text-white font-semibold">8AM - 7:30PM</span>
              </li>
              <li className="flex justify-between">
                <span className="text-gray-400">Saturday - Sunday</span>
                <span className="text-white font-semibold">Closed</span>
              </li>
              <li className="mt-6 pt-6 border-t border-navy-800">
                <span className="text-cyan-400 font-bold">
                  24/7 Emergency Services
                </span>
                <p className="text-gray-400 text-xs mt-1">
                  Locksmith available anytime
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-navy-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2024 Shiny Crew Cleaning. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/privacy" className="text-gray-400 hover:text-white">
                Privacy Policy
              </a>
              <a href="/terms" className="text-gray-400 hover:text-white">
                Terms of Service
              </a>
              <a href="/cookies" className="text-gray-400 hover:text-white">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
